/**
 * @generated SignedSource<<5656824de22cb293bbe80bf46d11fb90>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type pickerContent_autodevAgentPicker_jobRef$data = {
  readonly id: string;
  readonly " $fragmentType": "pickerContent_autodevAgentPicker_jobRef";
};
export type pickerContent_autodevAgentPicker_jobRef$key = {
  readonly " $data"?: pickerContent_autodevAgentPicker_jobRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"pickerContent_autodevAgentPicker_jobRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "pickerContent_autodevAgentPicker_jobRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraAutodevJob"
};

(node as any).hash = "5c5ad61bde20dbf862a689570aa375a6";

export default node;
